import { render, staticRenderFns } from "./case-record-chart.vue?vue&type=template&id=272a52e4&scoped=true"
import script from "./case-record-chart.vue?vue&type=script&lang=ts"
export * from "./case-record-chart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a52e4",
  null
  
)

export default component.exports